export enum SubscriptionStatus {
    'NotStarted'= 'NotStarted',
    'PendingFulfillmentStart' = 'PendingFulfillmentStart',
    'Subscribed' = 'Subscribed',
    'Suspended' = 'Suspended',
    'Unsubscribed' = 'Unsubscribed',
}